import { twMerge } from "tailwind-merge";

interface ListPageTopSectionProps {
  children: React.ReactNode;
  className?: string;
}

export default function ListPageTopSection({
  children,
  className,
}: ListPageTopSectionProps) {
  return (
    <div className={twMerge("flex h-[40px] items-center gap-1", className)}>
      {children}
    </div>
  );
}
